import { Suspense } from 'react';
import { PageLayoutProps } from './PageLayout.types';
import { useStyles } from './PageLayout.styles';
import { Loading } from '../../Loading';

export const PageLayout = ({
  header,
  topic,
  subTopic,
  topicTag,
  content,
  contentHeader,
  contentAside,
  styles: customStyles,
  classNames: customClassNames,
  children,
}: PageLayoutProps) => {
  const styles = useStyles({ header, topic, styles: customStyles, subTopic });
  return (
    <div role="grid" css={styles.root}>
      {header && <section css={styles.header}>{header}</section>}
      {topic && (
        <Suspense fallback={<Loading fullscreen size="sm" />}>
          <section data-testid="PageLayout-topic" css={styles.topic}>
            {topicTag && <div css={styles.topicTagContainer}>{topicTag}</div>}
            {topic}
          </section>
        </Suspense>
      )}
      {subTopic && (
        <section className={customClassNames?.subTopic} css={styles.subTopic}>
          {subTopic}
        </section>
      )}
      <Suspense fallback={<Loading fullscreen />}>
        <section css={styles.content}>
          <section css={styles.contentHeader}>{contentHeader}</section>
          <section css={styles.contentAside}>{contentAside}</section>
          <section css={styles.contentBody}>{content || children}</section>
        </section>
      </Suspense>
    </div>
  );
};
